package com.milta.feature.subscription.domain.usecase

import com.milta.feature.subscription.domain.entity.Subscription
import com.milta.feature.subscription.domain.repository.SubscriptionRepository

class GetMySubscriptionUseCase(private val repository: SubscriptionRepository) {
    suspend operator fun invoke(): Result<Subscription> = repository.getMySubscription()
}
